import script from "./8.AreasOfConcernInSkin.vue?vue&type=script&setup=true&lang=ts"
export * from "./8.AreasOfConcernInSkin.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__